<!-- committeeTabContainer -->
<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/committee']">Committee</a>
  </li>
  <li>Committee Details ({{committeeAlias}})</li>
</ul>



<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Committee Details ({{committeeAlias}})</strong>
    </span>
    <button class="btn btn-success pull-right" (click)="back()" class="btn btn-sm btn-default pull-right btn-back"
      type="button">
      <i class="fa fa-chevron-circle-left"></i> Back
    </button>
  </div>

  <div class="row">
    <div class="col-md-12" id="committeeTabContainer">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a id="committeeDetailsTab" class="nav-link active" data-target="#committeeDetails" data-toggle="tab" href="javascript: void(0);"
            role="tab" aria-selected="true">Committee Details</a>
        </li>
        <!-- <li class="nav-item" (click)="refreshTableOnTabClick('directorTable')">
            <a class="nav-link " data-target="#directorDetails" data-toggle="tab" href="javascript: void(0);" role="tab">Directors - Members</a>
          </li> -->
        <!-- <li class="nav-item" (click)="refreshTableOnTabClick('memberTable')">
            <a class="nav-link" data-target="#memberDetails" data-toggle="tab" href="javascript: void(0);" role="tab">Non Directors - Members</a>
          </li> -->
        <li class="nav-item" (click)="refreshTableOnTabClick('')">
          <a class="nav-link " data-target="#directorDetails" data-toggle="tab" href="javascript: void(0);"
            role="tab">Members</a>
        </li>
        <li class="nav-item" (click)="refreshTableOnTabClick('inviteeTable')">
          <a class="nav-link" data-target="#inviteesDetails" data-toggle="tab" href="javascript: void(0);"
            role="tab">Invitees Details</a>
        </li>

      </ul>

      <div class="tab-content">

        <div class="tab-pane active" id="committeeDetails" role="tabcard">

          <form [formGroup]="committeeEditForm" class="well">
            <div class="modal-body">

              <div class="row">


                <div class="col-md-2">
                  <label class="form-control-label" for="l0">Committee Type
                    <span style="color: red;">*</span>
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <select class="form-control" id="committeeName"
                      [formControl]="committeeEditForm.controls['committeeName']" style="padding:6px;"
                      aria-placeholder="Select committee name">
                      <option *ngFor="let committeeNameList of committeeName" [selected]="committeeNameList.IsSelected"
                        [value]="committeeNameList.name">{{committeeNameList.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2" *ngIf="otherCommitteeSelected">
                  <label class="form-control-label">Committee Name
                  </label>
                  <span style="color: red;">*</span>
                </div>
                <div class="col-md-4" *ngIf="otherCommitteeSelected">
                  <div class="form-group">
                    <input type="text" class="form-control" style="padding:6px;"
                      [formControl]="committeeEditForm.controls['otherCommitteeName']">
                    <div
                      *ngIf="isOtherNotValid || (committeeEditForm.controls['otherCommitteeName'].hasError('whitespace') && committeeEditForm.controls['otherCommitteeName'].touched)"
                      class="form-control-error-custom">
                      Name for Other Committee Type is required.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Committee-Alias
                    <span style="color: red;">*</span>
                  </label>

                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" [formControl]="committeeEditForm.controls['committeeAlias']" class="form-control"
                      style="padding:6px;">
                    <div
                      *ngIf="committeeEditForm.controls['committeeAlias'].hasError('required') && committeeEditForm.controls['committeeAlias'].touched"
                      class="form-control-error-custom">
                      Committee-Alias is required.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Committee Short Name
                    <!-- <span style="color: red;">*</span> -->
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" [formControl]="committeeEditForm.controls['CommitteeShortName']"
                      class="form-control" style="padding:6px;">
                    <!-- <div *ngIf="committeeEditForm.controls['CommitteeShortName'].hasError('required') && committeeEditForm.controls['CommitteeShortName'].touched"
                        class="form-control-error-custom">
                        Committee Short Name is required.
                      </div> -->
                  </div>
                </div>


                <div class="col-md-2">
                  <label class="form-control-label">Frequency - Number of meetings (In Year)
                    <span style="color: red;">*</span>
                  </label>

                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="number" min="1" [formControl]="committeeEditForm.controls['meetingFrequency']"
                      class="form-control" style="padding:6px;">
                    <div
                      *ngIf="committeeEditForm.controls['meetingFrequency'].hasError('required') && committeeEditForm.controls['meetingFrequency'].touched"
                      class="form-control-error-custom">
                      Frequency - Number of meetings is required.
                    </div>
                    <div *ngIf="committeeEditForm.controls['meetingFrequency'].errors?.min"
                      class="form-control-error-custom">
                      Minimum required number is 1.
                    </div>
                  </div>
                </div>


                <div class="col-md-2">
                  <label class="form-control-label">Gap - between meeting (In Days)

                  </label>

                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="number" min="0" [formControl]="committeeEditForm.controls['meetingGap']"
                      class="form-control" style="padding:6px;">

                    <div *ngIf="committeeEditForm.controls['meetingGap'].errors?.min" class="form-control-error-custom">
                      Minimum required number is 1.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label"> Date of Activation of Committee
                    <span style="color: red;">*</span>
                  </label>
                </div>
                <div class="col-md-4" (click)="$event.stopPropagation()" (document:click)="r1.close();">
                  <div class="form-group">
                    <div class="input-group">
                      <input class="form-control" [formControl]="committeeEditForm.controls['activationDate']"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" [minDate]="dateOfIncorpOfCompany"
                        [maxDate]="futureDate" name="documentdate" ngbDatepicker #r1="ngbDatepicker"
                        (focus)="r1.toggle();">
                      <button class="input-group-addon" type="button" (click)="r1.toggle();">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>

                      <div
                        *ngIf="committeeEditForm.controls['activationDate'].hasError('required') && committeeEditForm.controls['activationDate'].touched"
                        class="form-control-error-custom">
                        Date of Activation of Committee is required
                      </div>


                    </div>
                    <div *ngIf="!committeeEditForm.controls['activationDate'].valid" class="form-control-error-custom">
                      Date of Activation of Committee should be less than Incorporation Date Of Company.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label"> Quorum </label>
                  <!-- - No of Directors-->
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="number" min="0" [formControl]="committeeEditForm.controls['quorumDirectors']"
                      class="form-control" style="padding:6px;">
                  </div>
                  <div *ngIf="committeeEditForm.controls['quorumDirectors'].errors?.min"
                    class="form-control-error-custom">
                    Minimum required number is 1.
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label"> Notice period for meeting (In Days)
                    <span style="color: red;">*</span>
                  </label>

                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="number" min="0" [formControl]="committeeEditForm.controls['meetingNoticePeriod']"
                      class="form-control" style="padding:6px;">
                    <div
                      *ngIf="committeeEditForm.controls['meetingNoticePeriod'].hasError('required') && committeeEditForm.controls['meetingNoticePeriod'].touched"
                      class="form-control-error-custom">
                      Notice period for meeting is required.
                    </div>
                  </div>
                </div>


                <div class="col-md-2">
                  <label class="form-control-label">Statutory Committee
                    <span style="color: red;">*</span>
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="md-radio md-radio-inline">
                      <input id="statutoryCommitteeYes" type="radio"
                        [formControl]="committeeEditForm.controls['statutoryCommittee']" style="position:absolute"
                        name="statutoryCommittee" value="Yes" class="form-check-input">
                      <label for="statutoryCommitteeYes">Yes</label>
                    </div>
                    <div class="md-radio md-radio-inline">
                      <input id="statutoryCommitteeNo" type="radio"
                        [formControl]="committeeEditForm.controls['statutoryCommittee']" style="position:absolute"
                        name="statutoryCommittee" value="No" class="form-check-input">
                      <label for="statutoryCommitteeNo">No</label>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Sitting Fees per Meeting</label>

                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" OnlyNumber CommaSeperatedNumber
                      [formControl]="committeeEditForm.controls['sittingFees']" [ngModel]="settingAmount"
                      (input)="limitToAmount()" class="form-control" style="padding:6px;">
                    <div *ngIf="warningALertForSettingAmount" class="form-control-error-custom">
                      Amount must be less than Rs 100,000.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label"> Charter </label>

                </div>

                <!-- If charter file available -->
                <div class="col-md-4" *ngIf="charterFileIsAvailable">
                  <label class="input-group">
                    <input type="text" [formControl]="committeeEditForm.controls['charterFileDocId']"
                      class="form-control" style="padding:6px;" [(ngModel)]="charterFileDocName" readonly>
                    <a href="{{downloadLink}}{{charterFileDocID}}/{{token}}" class="input-group-addon btn default"
                      style="margin: 0px 0px;">
                      <span class="fa fa-download"></span>
                    </a>
                    <a class="input-group-addon" style="margin: 0px 0px;" (click)="addCharterImage()">
                      <span class="fa fa-upload "></span>
                    </a>
                  </label>
                </div>



                <!-- If charter file unavailable -->
                <div class="col-md-4" *ngIf="!charterFileIsAvailable">
                  <div class="form-group">
                    <label class="input-group">
                      <input type="text" class="form-control" style="padding:6px;" value="No File Available" readonly>
                      <a class="input-group-addon" style="margin: 0px 0px;" (click)="addCharterImage()"
                        [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                        <span class="fa fa-upload "></span>
                      </a>
                    </label>
                  </div>
                </div>


                <div class="col-md-2">
                  <label class="form-control-label"> Policies </label>
                </div>
                <!-- If policy file available -->
                <div class="col-md-4" *ngIf="policiesFileIsAvailable">
                  <label class="input-group">
                    <input type="text" [formControl]="committeeEditForm.controls['policiesFileDocId']"
                      class="form-control" style="padding:6px;" [(ngModel)]="policiesFileDocName" readonly>
                    <a href="{{downloadLink}}{{policiesFileDocID}}/{{token}}" class="input-group-addon btn default"
                      style="margin: 0px 0px;">
                      <span class="fa fa-download"></span>
                    </a>
                    <a class="input-group-addon " style="margin: 0px 0px;" (click)="addPolicyImage()">
                      <span class="fa fa-upload "></span>
                    </a>
                  </label>
                </div>

                <!-- If policy file unavailable -->
                <div class="col-md-3" *ngIf="!policiesFileIsAvailable">
                  <div class="form-group">
                    <label class="input-group">
                      <input type="text" class="form-control" style="padding:6px;" value="No File Available" readonly>
                      <a class="input-group-addon " style="margin: 0px 0px;" (click)="addPolicyImage()"
                        [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                        <span class="fa fa-upload "></span>
                      </a>
                    </label>
                  </div>
                </div>
              </div>

            </div>

            <div class="modal-footer">
              <button type="submit" class="btn-sm btn btn-primary" (click)='editCommittee()'
                [disabled]="!committeeEditForm.valid || disabledOnclick" id="editBtnAgenda"
                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                <i class="fa fa-save"></i>Update</button>
              <!-- <button type="submit" class="btn-sm btn btn-default" data-toggle="modal" data-target="#clearDataModal" [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                  <i class="fa fa-times"></i>Clear</button> -->
            </div>
          </form>

        </div>

        <!-- <div class="tab-pane " id="directorDetails" role="tabcard">
  
            <section class="card">
              <div class="card-header">
                <span class="cat__core__title">
                  Directors Details:
                  <div class="pull-right">
                    <button type="button" class="btn btn-sm btn-primary ml-2" data-toggle="modal" (click)="loadModelForAddDirector();" data-target="#directorDialog"
                      [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                      <i class="fa fa-plus"></i>Add</button>
                  </div>
                </span>
              </div>
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsDirector" [dtTrigger]="dtTriggerDirector" class="table table-hover compact cell-border nowrap stripe"
                          id="directorTable">
                          <thead>
                            <tr>
                              <th>Name of Director</th>
                              <th>Designation</th>
                              <th>Category</th>
                              <th>Executive / Non-Executive</th>
                              <th>Chairman</th>
                              <th>Date of Appointment</th>
                              <th>
                                <span [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">Action</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let director of allDirectorDetailsForCommittee; let i = index" style="line-height: 25px;">
                              <td>
                                <label>{{director.DirectorName}}</label>
                              </td>
                              <td>
                                <label>{{director.Designation}}</label>
                              </td>
                              <td>
                                <label>{{director.Category}}</label>
                              </td>
                              <td>{{director.IsExecutive}}
                                
                              </td>
                              <td>{{director.Chairman}}</td>
                              <td>
                                <span style="display: none">{{director.AppointmentDate | date : "yMMdd"}}</span>
                                <label>{{director.AppointmentDate | date : "dd-MM-y"}}</label>
                              </td>
                              <td>
                                <button class="btn-sm btn btn-warning" type="button" data-toggle="modal" (click)="loadToEditDirector(director)" data-target="directorDialog"
                                  [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                                  <span class="fa fa-pencil"></span>
                                </button>
                                <button class="btn-sm btn btn-danger" data-toggle="modal" data-target="deleteModal" (click)="confirmationToDeleteDirector(director._id)"
                                  type="button" [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                                  <span class="icmn-bin"></span>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
  
          </div> -->

        <div class="tab-pane " id="directorDetails" role="tabcard">

          <section class="card">
            <div class="card-header">
              <span class="cat__core__title">
                Member Details:
                <div class="pull-right">
                  <button type="button" class="btn btn-sm btn-primary ml-2" (click)="loadModelForAddDirector();"
                    data-target="#directorDialog"
                    [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                    <i class="fa fa-plus"></i>Add</button>
                </div>
              </span>
            </div>
            <section class="card search-box">
              <div class="card-header" data-toggle="collapse" data-target="#search-div">Modify Search
                <span class="pull-right">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </span>
              </div>
              <div class="card-block collapse" id="search-div">
                <div class="row">
                  <div class="col-lg-12">
                    <form (document:click)="c.close();r.close();r1.close();">
                      <div class="row">
                        <!-- <div class="col-sm-2">
                          <label>Meeting Type :</label>
                          
                          <div class="input-group">
                            <select id="drpmeeting" [(ngModel)]="selectedMeeting" class="form-control" (ngModelChange)="getMeetingFromType()" [ngModelOptions]="{standalone:true}">
                              <option value=null [selected]="true">Select</option>
                              <option *ngFor="let meetingTypeList of meetingType" [ngValue]="meetingTypeList._id">{{meetingTypeList.MeetingType}}</option>
                            </select>
                          </div>
                        </div> -->

                        <!--Meeting  filter Dropduwn -->
                        <!-- <div class="col-sm-2">
                          <label>Meetings Date:</label>
          
                          <div class="input-group">
                            <select class=" form-control" [(ngModel)]="meetingsSearch" [ngModelOptions]="{standalone:true}">
                              <option value=null [selected]="true">Select</option>
                              <option *ngFor="let meeting of meetingDateOnSelectedType" [value]="meeting._id">{{meeting.meetingList.MeetingDate | date: "dd-MM-y"}} {{meeting.meetingList.MeetingTime}}</option>
                            </select>
                          </div>
                        </div> -->
                        <div class="col-sm-4">
                          <label>Date Range:</label>
                          <!--Meeting Date Range filter From and To Date Functionality -->
                          <div class="input-group" (click)="$event.stopPropagation()">

                            From:&nbsp;
                            <input class="form-control" [(ngModel)]="userSearchDateFrom" style="padding:6px;z-index: 0;"
                              placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker" (focus)="c.toggle();r.close();"
                              (document:click)="c.close();" [minDate]="minDateForSearchFrom"
                              (ngModelChange)="filterUserByDate()" [ngModelOptions]="{standalone: true}">
                            <button class="input-group-addon" (click)="c.toggle();r.close();" type="button">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button> &nbsp;&nbsp; To:&nbsp;
                            <input class="form-control" [(ngModel)]="userSearchDateTo" style="padding:6px;z-index: 0;"
                              placeholder="dd-mm-yyyy" ngbDatepicker #r="ngbDatepicker" (focus)="r.toggle();c.close();"
                              (document:click)="r.close();" [minDate]="minDateForSearchTo"
                              [ngModelOptions]="{standalone: true}">
                            <button class="input-group-addon" (click)="r.toggle();c.close();" type="button">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                          </div>

                        </div>

                        <div class="col-sm-2">
                          <label>&nbsp;&nbsp;&nbsp;</label>
                          <div class="input-group">
                            <!-- getMeetingByParam() -->
                            <button type="button" class="btn btn-sm btn-primary mb-2"
                              (click)="refreshTableOnTabClick('')">
                              <i class="fa fa-search"></i>Search</button>
                            &nbsp;&nbsp;&nbsp;
                            <button type="button" class="btn btn-sm btn-default mb-2" (click)="clear()">
                              <i class="fa fa-refresh"></i>Clear</button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
            <div class="card-block datatable-card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="margin-bottom-50">
                    <div class="table-responsive">
                      <table datatable [dtOptions]="dtOptionsDirector" [dtTrigger]="dtTriggerDirector"
                        class="table table-hover compact cell-border nowrap stripe" id="directorTable">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Category</th>
                            <th>Executive / Non-Executive</th>
                            <th>Chairman</th>
                            <th>Date of Appointment</th>
                            <th>
                              <span
                                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">Action</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let director of allDirectorDetailsForCommittee; let i = index"
                            style="line-height: 25px;">
                            <td>
                              <label>{{director.name}}</label>
                            </td>
                            <td>
                              <label>{{director.Designation}}</label>
                            </td>
                            <td>
                              <label>{{director.Category}}</label>
                            </td>
                            <td>{{director.IsExecutive}}
                              <!-- <span *ngIf="director.IsExecutive">
                                  Executive
                                </span>
                                <span *ngIf="!director.IsExecutive">
                                  Non-Executive
                                </span> -->
                            </td>
                            <td>{{director.Chairman}}</td>
                            <td>
                              <span style="display: none">{{director.AppointmentDate | date : "yMMdd"}}</span>
                              <label>{{director.AppointmentDate | date : "dd-MM-y"}}</label>
                            </td>
                            <td>
                              <button class="btn-sm btn btn-warning" type="button"
                                (click)="loadToEditDirector(director)" data-target="directorDialog"
                                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button class="btn-sm btn btn-danger" data-toggle="modal" data-target="deleteModal"
                                (click)="deleteUser(director._id, director.userType)" type="button"
                                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                                <span class="icmn-bin"></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>

        <div class="tab-pane" id="inviteesDetails" role="tabcard">
          <section class="card">
            <div class="card-header">
              <span class="cat__core__title">
                Invitees Details:


                <span style="float: right">
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-sm btn-primary ml-2" (click)="addInvitee();"
                      data-target="#msgDialog"
                      [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                      <i class="fa fa-plus"></i>Invitee with no access</button>
                    <button type="button" *ngIf="!environmentSettings.PSS" class="btn btn-sm btn-primary"
                      (click)="getMembersFromGovevaForInvitee()" data-target="#existingInviteeDialog"
                      [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                      <i class="fa fa-plus"></i> Choose Existing Invitee</button>

                  </div>
                </span>

              </span>
            </div>
            <div class="card-block datatable-card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="margin-bottom-50">
                    <div class="table-responsive">
                      <table datatable [dtOptions]="dtOptionsInvitee" [dtTrigger]="dtTriggerInvitee"
                        class="table table-hover compact cell-border nowrap stripe" id="inviteeTable">
                        <thead>
                          <tr>
                            <th tabindex="1">Invitee Name</th>
                            <th>Designation</th>
                            <th tabindex="1">Mobile No</th>
                            <th tabindex="1">Email Id</th>
                            <th tabindex="1">In Attendance</th>
                            <th tabindex="1">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let invitee of invityMember; let i = index ">
                            <td tabindex="1">{{invitee.InviteeName}}</td>
                            <td tabindex="1">{{invitee.Designation}}</td>
                            <td tabindex="1">{{invitee.MobileNo}}</td>
                            <td tabindex="1">{{maskEmail(invitee.EmailId)}}</td>
                            <td tabindex="1">
                              <span *ngIf="invitee.InAttendance == 'Yes'">In-Attendance</span>
                              <span *ngIf="invitee.InAttendance == 'No'">Permanent Invitee</span>
                            </td>
                            <td tabindex="1">

                              <button *ngIf="invitee.UserGovevaId==null || invitee.UserGovevaId=='null'"
                                class="btn-sm btn btn-warning" type="button" data-toggle="modal"
                                (click)="loadToEditInvitee(invitee)" data-target="inviteeDialog">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button type="button" class="btn-sm btn btn-danger" data-toggle="modal"
                                data-target="deleteModal" (click)="confirmationToDeleteInvitee(invitee._id)">
                                <span class="icmn-bin"></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="tab-pane" id="memberDetails" role="tabcard">
          <section class="card">
            <div class="card-header">
              <span class="cat__core__title">
                Members Details:
                <div class="pull-right">
                  <button type="button" class="btn btn-sm btn-primary ml-2" data-toggle="modal" (click)="addMember();"
                    data-target="#memberDialog"
                    [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                    <i class="fa fa-plus"></i>Add</button>
                </div>
              </span>
            </div>
            <div class="card-block datatable-card-block">
              <div class="row">

                <div class="col-md-12">
                  <div class="margin-bottom-50">
                    <div class="table-responsive">
                      <table datatable [dtOptions]="dtOptionsMember" [dtTrigger]="dtTriggerMember"
                        class="table table-hover compact cell-border nowrap stripe" id="memberTable">
                        <thead>
                          <tr>
                            <th>Member Name</th>
                            <th>Designation</th>
                            <th>Mobile No</th>
                            <th>Email Id</th>

                            <th>
                              <span
                                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">Action</span>
                            </th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Member of committeeMember; let i = index ">

                            <td>{{Member.MemberName}}</td>
                            <td>{{Member.Designation}}</td>
                            <td>{{Member.MobileNo}}</td>
                            <td>{{Member.EmailId}}</td>


                            <!-- For GovEva    -->

                            <!-- <td tabindex="1">{{Member.FirstName }} {{Member.LastName }}</td>
                              <td tabindex="1">{{Member.TypeOfUser }}</td>
                              <td tabindex="1">{{Member.EmailId }}</td>
                              <td tabindex="1">{{Member.MobileNumber }}</td> -->


                            <td>
                              <button class="btn-sm btn btn-warning" *ngIf="environmentSettings.PSS" type="button"
                                data-toggle="modal" (click)="loadToEditMember(Member)" data-target="inviteeDialog"
                                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button type="button" class="btn-sm btn btn-danger" data-toggle="modal"
                                data-target="deleteModal" (click)="confirmationToDeleteMember(Member._id)"
                                [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
                                <span class="icmn-bin"></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

      </div>
    </div>
  </div>

  <div class="modal fade" id="uploadNewFile" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-pencil"></i>Upload New File
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row" *ngIf="policyFileEditFlag">
                <div class="col-md-4">
                  <label class="form-control-label">Policy File</label>

                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <input type="file" class="form-control fileUpload" (change)="policyfileChangeEvent($event)"
                      accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx">
                    <span style="color: red" *ngIf="!changefileExtension">Please upload valid file format.</span>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="charterFileEditFlag">
                <div class="col-md-4">
                  <label class="form-control-label">Charter File</label>

                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <input type="file" class="form-control fileUpload" (change)="charterfileChangeEvent($event)"
                      accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx">
                    <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" id="charterFileSaveBTN"
            (click)="uploadCharterFileFromPOPUP()" [disabled]="!fileExtension">
            <i class="fa fa-save"></i>Update</button>
          <button type="button" class="btn btn-sm btn-primary" id="policyFileSaveBTN"
            (click)="uploadPolicyFileFromPOPUP()" [disabled]="!changefileExtension">
            <i class="fa fa-save"></i>Update</button>

          <button type="button" class="btn btn-sm" data-dismiss="modal">
            <i class="fa fa-times"></i>Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-large" id="directorDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h5 class="modal-title" id="DirectorLabel">Member Details :
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="modal-body">

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Member Type
                  <span style="color: red;" class="span_margin">*</span>
                </label>
              </div>
              <div class="col-md-4" *ngIf="editActive">
                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="directorType" type="radio" style="position:absolute"
                      [formControl]="directorForm.controls['MemberType']" name="MemberType"
                      (change)="getUserByType(directorForm.controls['MemberType'].value)" value="Director"
                      class="form-check-input" disabled>
                    <label for="directorType">Director</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="otherType" type="radio" style="position:absolute"
                      [formControl]="directorForm.controls['MemberType']" name="MemberType"
                      (change)="getUserByType(directorForm.controls['MemberType'].value)" value="Member"
                      class="form-check-input" disabled>
                    <label for="otherType">Other</label>
                  </div>
                </div>
              </div>

              <div class="col-md-4" *ngIf="!editActive">
                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="directorType" type="radio" style="position:absolute"
                      [formControl]="directorForm.controls['MemberType']" name="MemberType"
                      (change)="getUserByType(directorForm.controls['MemberType'].value)" value="Director"
                      class="form-check-input">
                    <label for="directorType">Director</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="otherType" type="radio" style="position:absolute"
                      [formControl]="directorForm.controls['MemberType']" name="MemberType"
                      (change)="getUserByType(directorForm.controls['MemberType'].value)" value="Member"
                      class="form-check-input">
                    <label for="otherType">Other</label>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-2">
                  <label class="form-control-label">Select Director
                    <span style="color: red;" class="span_margin">*</span>
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <select class="form-control" (change)="getDirectorDetails($event)" [formControl]="directorForm.controls['DirectorDIN']">
                      <option value='null' [selected]="true">Select</option>
                      <option *ngFor="let DinData of directorData" [value]="DinData.Din">
                        {{DinData.FirstName}} {{DinData.LastName}}
                        
                      </option>
                    </select>
                    <div *ngIf="directorForm.controls['DirectorDIN'].hasError('required') && directorForm.controls['DirectorDIN'].touched" class="form-control-error-custom">
                      Please select Director
                    </div>
                    <div *ngIf="directorIsNotValid" class="form-control-error-custom">
                      Please Complete the director professional details before adding to Committee.
                    </div>
                  </div>
                </div> -->
              <div class="col-md-2">
                <label class="form-control-label">Is Chairman
                  <span style="color: red;" class="span_margin">*</span>
                </label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="isChairmanY" type="radio" style="position:absolute"
                      [formControl]="directorForm.controls['Chairman']" name="isChairman" value="Yes"
                      class="form-check-input">
                    <label for="isChairmanY">Yes</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="isChairmanN" type="radio" style="position:absolute"
                      [formControl]="directorForm.controls['Chairman']" name="isChairman" value="No"
                      class="form-check-input">
                    <label for="isChairmanN">No</label>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Select Member
                  <span style="color: red;" class="span_margin">*</span>
                </label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <select class="form-control"
                    (change)="getDirectorDetails($event, directorForm.controls['MemberType'].value)"
                    [formControl]="directorForm.controls['DirectorID']" *ngIf="update == false">
                    <option value='null' [selected]="true">Select</option>
                    <option *ngFor="let DinData of directorData" [value]="DinData._id">
                      {{DinData.FirstName}} {{DinData.LastName}}

                    </option>
                  </select>
                  <select class="form-control"
                    (change)="getDirectorDetails($event, directorForm.controls['MemberType'].value)"
                    [formControl]="directorForm.controls['DirectorID']" *ngIf="update == true">
                    <option value='null' [selected]="true">Select</option>
                    <option *ngFor="let DinData of directorData" [value]="DinData._id">
                      {{DinData.FirstName}} {{DinData.LastName}}

                    </option>
                  </select>
                  <div
                    *ngIf="directorForm.controls['DirectorID'].hasError('required') && directorForm.controls['DirectorID'].touched"
                    class="form-control-error-custom">
                    Please select Director
                  </div>
                  <div *ngIf="directorIsNotValid" class="form-control-error-custom">
                    Please Complete the director professional details before adding to Committee.
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-2">
                  <label class="form-control-label">Director Name</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="hidden" class="form-control">
                    <input type="hidden" [formControl]="directorForm.controls['DirectorID']" class="form-control">
                    <input [formControl]="directorForm.controls['MemberName']" class="form-control" readonly>
                  </div>
                </div> -->
              <div class="col-md-2">
                <label class="form-control-label">Designation</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="directorForm.controls['Designation']" class="form-control" readonly>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">
                  <span *ngIf="directorForm.controls['MemberType'].value == 'Director'">Director</span>
                  <span *ngIf="directorForm.controls['MemberType'].value == 'Member'">Member</span> Name</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input type="hidden" class="form-control">
                  <input type="hidden" [formControl]="directorForm.controls['DirectorID']" class="form-control">
                  <input [formControl]="directorForm.controls['MemberName']" class="form-control" readonly>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-control-label">Appointment Date</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="input-group" (click)="$event.stopPropagation()" (document:click)="ap.close();">
                    <input class="form-control" [formControl]="directorForm.controls['AppointmentDate']"
                      [minDate]="maxdateOfApp" style="padding:6px;" placeholder="dd-mm-yyyy" name="AppointmentDate"
                      [(ngModel)]="DirectorAppointmentDate" ngbDatepicker #ap="ngbDatepicker"
                      (click)="ap.toggle();cs.close();" required="required">
                    <button class="input-group-addon" (click)="ap.toggle();cs.close();ten.close()" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                  <div
                    *ngIf="directorForm.controls['AppointmentDate'].hasError('required') && directorForm.controls['AppointmentDate'].touched"
                    class="form-control-error-custom">
                    Please select Appointment Date
                  </div>
                  <div
                    *ngIf="!directorForm.controls['AppointmentDate'].valid && directorForm.controls['AppointmentDate'].touched"
                    class="form-control-error-custom">
                    Appointment Date should not be less than Date of Activation of Committee also Should not be less
                    than Company Appointment
                    Date Of Director.
                  </div>
                </div>


              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Cessation Date</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="input-group" (click)="$event.stopPropagation()" (document:click)="cs.close();">
                    <input class="form-control" [formControl]="directorForm.controls['CessationDate']"
                      style="padding:6px;" placeholder="dd-mm-yyyy" name="CessationDate" ngbDatepicker
                      #cs="ngbDatepicker" [minDate]="DirectorAppointmentDate" (click)="cs.toggle();ap.close();">

                    <button class="input-group-addon" (click)="cs.toggle(); ap.close();ten.close()" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                  <div *ngIf="!directorForm.controls['CessationDate'].valid" class="form-control-error-custom">
                    Cessation Date should be less than Appointment Date.
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-control-label">Cessation Reason</label>
              </div>
              <div class="col-md-4">
                <input [formControl]="directorForm.controls['CessationReason']" class="form-control">
              </div>
            </div>

            <div class="row">
              <div class="col-md-2" *ngIf="isAuditCommitteeAvailable">
                <label class="form-control-label">Financial Literate</label>
              </div>
              <div class="col-md-4" *ngIf="isAuditCommitteeAvailable">
                <div class="form-group">
                  <div class="md-radio md-radio-inline">
                    <input id="FinancialYes" type="radio" name="Financial"
                      [formControl]="directorForm.controls['financialLiterate']" value="Yes" class="form-check-input">
                    <label for="FinancialYes">Yes</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="FinancialNo" type="radio" name="Financial"
                      [formControl]="directorForm.controls['financialLiterate']" value="No" class="form-check-input">
                    <label for="FinancialNo">No</label>
                  </div>
                </div>
              </div>
              <div class="col-md-2" *ngIf="isAuditCommitteeAvailable">
                <label class="form-control-label">Accounting or related financial management expertise</label>
              </div>
              <div class="col-md-4" *ngIf="isAuditCommitteeAvailable">
                <div class="form-group">
                  <div class="md-radio md-radio-inline">
                    <input id="AccYes" type="radio" name="Accounting"
                      [formControl]="directorForm.controls['accountingOrRelatedFinancialExpertise']" value="Yes"
                      class="form-check-input">
                    <label for="AccYes">Yes</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="AccNO" type="radio" name="Accounting"
                      [formControl]="directorForm.controls['accountingOrRelatedFinancialExpertise']" value="No"
                      class="form-check-input">
                    <label for="AccNO">No</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="directorForm.controls['MemberType'].value == 'Director'">
              <div class="col-md-2">
                <label class="form-control-label">Category</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="directorForm.controls['Category']" class="form-control" readonly>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-control-label">Executive / Non-Executive</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="directorForm.controls['IsExecutive']" class="form-control" readonly>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">End of Term Date</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <!-- Changed input field to date field -->
                  <!-- <input [formControl]="directorForm.controls['Tenure']" class="form-control"> -->
                  <div class="input-group" (click)="$event.stopPropagation()" (document:click)="ten.close();">
                    <input class="form-control" [formControl]="directorForm.controls['Tenure']" style="padding:6px;"
                      placeholder="dd-mm-yyyy" name="Tenure" ngbDatepicker #ten="ngbDatepicker"
                      (click)="ten.toggle();ap.close();cs.close();">

                    <button class="input-group-addon" (click)="ten.toggle(); ap.close();cs.close();" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button id="btnUpdateDirectorRow" type="button" class="btn-sm btn btn-primary" *ngIf="editActive"
              [disabled]="!directorForm.valid || disabledOnclick"
              (click)="updateUser(directorForm.controls['MemberType'].value)">
              <i class="fa fa-save"></i> Update
            </button>

            <button id="btnaddDirectorRow"  *ngIf="!editActive" type="submit" class="btn-sm btn btn-primary"
              [disabled]="!directorForm.valid  || disabledOnclick" (click)="saveDirectors()">
              <i class="fa fa-save"></i>Save</button>
            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-large" id="inviteeDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h5 class="modal-title" id="InviteeLabel">Invitee Details :
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="modal-body">

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Invitee Name</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['InviteeName']" class="form-control">
                  <div
                    *ngIf="inviteeForm.controls['InviteeName'].hasError('required') && inviteeForm.controls['InviteeName'].touched"
                    class="form-control-error-custom">
                    Invitee Name is required.
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-control-label">Designation</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['Designation']" class="form-control">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Address</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['Address']" class="form-control">
                </div>
              </div>


              <div class="col-md-2">
                <label class="form-control-label">City</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['City']" class="form-control"
                    (keydown)="onlyAlphabates($event)">
                  <div *ngIf="inviteeForm.controls['City'].hasError('pattern') && inviteeForm.controls['City'].touched"
                    class="form-control-error-custom">
                    City is invalid.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">State</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="input-group">
                    <input [formControl]="inviteeForm.controls['State']" class="form-control">
                  </div>

                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Tel(O)</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['TelO']" class="form-control" pattern="^\d{4}\d{3}\d{4}$">
                  <div *ngIf="inviteeForm.controls['TelO'].hasError('pattern') && inviteeForm.controls['TelO'].touched"
                    class="form-control-error-custom">
                    Telephone number is invalid.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Tel(R)</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['TelR']" class="form-control" pattern="^\d{4}\d{3}\d{4}$">
                  <div *ngIf="inviteeForm.controls['TelR'].hasError('pattern') && inviteeForm.controls['TelR'].touched"
                    class="form-control-error-custom">
                    Telephone number is invalid.
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Through VC</label>
              </div>
              <div class="col-md-4">


                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="ThroughVCY" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['ThroughVC']" name="ThroughVC" value="Yes"
                      class="form-check-input">
                    <label for="ThroughVCY">Yes</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="ThroughVCN" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['ThroughVC']" name="ThroughVC" value="No"
                      class="form-check-input">
                    <label for="ThroughVCN">No</label>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Fax No</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['FaxNo']" class="form-control" pattern="^\+?[0-9]{7,}$">
                  <div
                    *ngIf="inviteeForm.controls['FaxNo'].hasError('pattern') && inviteeForm.controls['FaxNo'].touched"
                    class="form-control-error-custom">
                    Fax Number is not valid.
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Mobile No</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <input [formControl]="inviteeForm.controls['MobileNo']" id="invitteeMob" class="form-control"
                  pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                <div
                  *ngIf="inviteeForm.controls['MobileNo'].hasError('pattern') && inviteeForm.controls['MobileNo'].touched"
                  class="form-control-error-custom">
                  Mobile Number is not valid.
                </div>
                <div
                  *ngIf="inviteeForm.controls['MobileNo'].hasError('required') && inviteeForm.controls['MobileNo'].touched"
                  class="form-control-error-custom">
                  Mobile Number is required.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Email Id</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input type="email" [formControl]="inviteeForm.controls['EmailId']"
                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" class="form-control">
                  <div
                    *ngIf="inviteeForm.controls['EmailId'].hasError('required') && inviteeForm.controls['EmailId'].touched"
                    class="form-control-error-custom">
                    Email Id is required.
                  </div>
                  <div *ngIf="inviteeForm.controls['EmailId'].hasError('pattern') " class="form-control-error-custom">
                    Email Id is incorrect.
                  </div>
                  <div *ngIf="checkEmailIdExistInInvitee" class="form-control-error-custom">
                    Email Id is already exist.
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Invitees attendance
                  <span style="color: red;" class="span_margin">*</span>
                </label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="InAttendanceY" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['InAttendance']" name="InAttendance" value="Yes"
                      class="form-check-input">
                    <label for="InAttendanceY">In-Attendance</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="InAttendanceN" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['InAttendance']" name="InAttendance" value="No"
                      class="form-check-input">
                    <label for="InAttendanceN">Permanent Invitee</label>
                  </div>



                </div>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <div *ngIf="alreadyExist" class="form-control-error-custom text_center">This User is already exists in
              Members Details</div>
            <button id="btnUpdateInviteeRow" type="button" class="btn-sm btn btn-primary"
              [disabled]="!inviteeForm.valid || disabledOnclick" (click)="updateInvitee()" style="display:none">
              <i class="fa fa-save"></i>Update</button>
            <button id="btnaddInviteeRow" type="submit" class="btn-sm btn btn-primary"
              [disabled]="!inviteeForm.valid || disabledOnclick" (click)="saveInvitee()">
              <i class="fa fa-save"></i>Save</button>
            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal fade modal-size-small" id="msgDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="MemberLabel">Alert :
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>This invitee will not be able to LOGIN or use the E-meeting for accessing the documents. If you want to
            give access to any such invitee then please select "Choose existing invitee"</p>
        </div>
        <div class="modal-footer">
          <!-- <button id="btnaddMemberRow" type="submit" class="btn-sm btn btn-primary" data-dismiss="modal" data-toggle="modal">
        <i class="fa fa-save"></i>Yes</button> -->
          <button type="button" class="btn-sm btn btn-default" (click)="showinviteeDialog()"
            data-target="#inviteeDialog" data-dismiss="modal">
            <i class="fa fa-times"></i>ok</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-size-large" id="memberDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div id="pssAddMemberForm" *ngIf="environmentSettings.PSS">
          <form>
            <div class="modal-header">
              <h5 class="modal-title" id="MemberLabel">Member Details :
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-times"></i>
              </button>
            </div>

            <div class="modal-body">

              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Member Name</label>
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['MemberName']" class="form-control">
                    <div
                      *ngIf="memberForm.controls['MemberName'].hasError('required') && memberForm.controls['MemberName'].touched"
                      class="form-control-error-custom">
                      Member Name is required.
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-control-label">Designation</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['Designation']" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Address</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['Address']" class="form-control">
                  </div>
                </div>


                <div class="col-md-2">
                  <label class="form-control-label">City</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['City']" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">State</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="input-group">
                      <input [formControl]="memberForm.controls['State']" class="form-control">
                    </div>

                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Tel(O)</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['TelO']" class="form-control" pattern="^\d{4}\d{3}\d{4}$">
                    <div *ngIf="memberForm.controls['TelO'].hasError('pattern') && memberForm.controls['TelO'].touched"
                      class="form-control-error-custom">
                      Telephone number is not valid.
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Tel(R)</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['TelR']" class="form-control" pattern="^\d{4}\d{3}\d{4}$">
                    <div *ngIf="memberForm.controls['TelR'].hasError('pattern') && memberForm.controls['TelR'].touched"
                      class="form-control-error-custom">
                      Telephone number is not valid.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Mobile No</label>
                </div>
                <div class="col-md-4">
                  <input [formControl]="memberForm.controls['MobileNo']" id="memberMob" class="form-control"
                    pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                  <div
                    *ngIf="memberForm.controls['MobileNo'].hasError('pattern') && memberForm.controls['MobileNo'].touched"
                    class="form-control-error-custom">
                    Mobile Number is not valid.
                  </div>
                </div>

              </div>


              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Fax No</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['FaxNo']" class="form-control" pattern="^\+?[0-9]{7,}$">
                    <div
                      *ngIf="memberForm.controls['FaxNo'].hasError('pattern') && memberForm.controls['FaxNo'].touched"
                      class="form-control-error-custom">
                      Fax number is not valid.
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-control-label">Is Chairman
                    <span style="color: red;" class="span_margin">*</span>
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">

                    <div class="md-radio md-radio-inline">
                      <input id="isChairmanMemberY" type="radio" style="position:absolute"
                        [formControl]="memberForm.controls['Chairman']" name="isChairmanMember" value="Yes"
                        class="form-check-input">
                      <label for="isChairmanMemberY">Yes</label>
                    </div>
                    <div class="md-radio md-radio-inline">
                      <input id="isChairmanMemberN" type="radio" style="position:absolute"
                        [formControl]="memberForm.controls['Chairman']" name="isChairmanMember" value="No"
                        class="form-check-input">
                      <label for="isChairmanMemberN">No</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Email Id</label>
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="email" [formControl]="memberForm.controls['EmailId']"
                      pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" class="form-control">
                    <div
                      *ngIf="memberForm.controls['EmailId'].hasError('required') && memberForm.controls['EmailId'].touched"
                      class="form-control-error-custom">
                      Email Id is required.
                    </div>
                    <div *ngIf="memberForm.controls['EmailId'].hasError('pattern')" class="form-control-error-custom">
                      Email Id is incorrect.
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-control-label">Appointment Date</label>
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="input-group" (click)="$event.stopPropagation()" (document:click)="apdM.close();">
                      <input class="form-control" [formControl]="memberForm.controls['AppointmentDate']"
                        [(ngModel)]="memberAppointmentDate" [minDate]="maxdateOfApp" style="padding:6px;"
                        placeholder="dd-mm-yyyy" name="AppointmentDate" ngbDatepicker #apdM="ngbDatepicker"
                        (click)="apdM.toggle();csdM.close();" required="required">
                      <button class="input-group-addon" (click)="apdM.toggle();csdM.close();" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                    <div
                      *ngIf="memberForm.controls['AppointmentDate'].hasError('required') && memberForm.controls['AppointmentDate'].touched"
                      class="form-control-error-custom">
                      Please select Appointment Date.
                    </div>
                    <div
                      *ngIf="!memberForm.controls['AppointmentDate'].valid && memberForm.controls['AppointmentDate'].touched"
                      class="form-control-error-custom">
                      Appointment Date should not be less than Date of Activation of Committee.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Cessation Date</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="input-group" (click)="$event.stopPropagation()" (document:click)="csdM.close();">
                      <input class="form-control" [formControl]="memberForm.controls['CessationDate']"
                        [minDate]="memberAppointmentDate" style="padding:6px;" placeholder="dd-mm-yyyy"
                        name="CessationDate" ngbDatepicker #csdM="ngbDatepicker" (click)="csdM.toggle();apdM.close();">

                      <button class="input-group-addon" (click)="csdM.toggle(); apdM.close();" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-control-label">Cessation Reason</label>
                </div>
                <div class="col-md-4">
                  <input [formControl]="memberForm.controls['CessationReason']" class="form-control">
                </div>
              </div>



              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">End of Term Date</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="memberForm.controls['Tenure']" class="form-control">
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-2" *ngIf="isAuditCommitteeAvailable">
                  <label class="form-control-label">Financial Literate</label>
                </div>
                <div class="col-md-4" *ngIf="isAuditCommitteeAvailable">
                  <div class="form-group">
                    <div class="md-radio md-radio-inline">
                      <input id="MFinancialYes" type="radio" name="Financial"
                        [formControl]="memberForm.controls['financialLiterate']" value="Yes" class="form-check-input">
                      <label for="MFinancialYes">Yes</label>
                    </div>
                    <div class="md-radio md-radio-inline">
                      <input id="MFinancialNo" type="radio" name="Financial"
                        [formControl]="memberForm.controls['financialLiterate']" value="No" class="form-check-input">
                      <label for="MFinancialNo">No</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-2" *ngIf="isAuditCommitteeAvailable">
                  <label class="form-control-label">Accounting or related financial management expertise</label>
                </div>
                <div class="col-md-4" *ngIf="isAuditCommitteeAvailable">
                  <div class="form-group">
                    <div class="md-radio md-radio-inline">
                      <input id="MAccYes" type="radio" name="Accounting"
                        [formControl]="memberForm.controls['accountingOrRelatedFinancialExpertise']" value="Yes"
                        class="form-check-input">
                      <label for="MAccYes">Yes</label>
                    </div>
                    <div class="md-radio md-radio-inline">
                      <input id="MAccNO" type="radio" name="Accounting"
                        [formControl]="memberForm.controls['accountingOrRelatedFinancialExpertise']" value="No"
                        class="form-check-input">
                      <label for="MAccNO">No</label>
                    </div>
                  </div>
                </div>
              </div>


            </div>



            <div class="modal-footer">
              <div *ngIf="alreadyExist" class="form-control-error-custom text_center">This User is already exists in
                Members Details</div>
              <button id="btnaddMemberRow" type="submit" class="btn-sm btn btn-primary" [disabled]="!memberForm.valid"
                (click)="saveMember()">
                <i class="fa fa-save"></i>Save</button>
              <button id="btnUpdateMemberRow" type="button" class="btn-sm btn btn-primary"
                [disabled]="!memberForm.valid" (click)="updateMember()" style="display:none">
                <i class="fa fa-save"></i>Update</button>
              <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                <i class="fa fa-times"></i>Close</button>
            </div>

          </form>
        </div>


        <!--For Integration To Goveva END -->
        <div id="govEvaAddMemberForm" *ngIf="!environmentSettings.PSS">
          <div class="modal-header">
            <h5 class="modal-title" id="MemberLabel">Member Details :
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="margin-bottom-50">
                <div class="table-responsive">

                  <table datatable [dtOptions]="dtOptionsMemberAddingPopup" [dtTrigger]="dtTriggerMemberAddingPopup"
                    class="table table-hover compact cell-border nowrap stripe" id="memberTablePopup"
                    style="cursor: pointer;">
                    <thead>
                      <tr>
                        <th class="process-list-action">
                          <div class="md-checkbox">
                            <input id="selectProcesscheckboxall" class="md-checkbox" type="checkbox"
                              (change)="selectAllMembers($event);" />
                            <label for="selectProcesscheckboxall">&nbsp;</label>
                          </div>
                        </th>
                        <th> Member Name </th>
                        <th> Member Type </th>
                        <th> Email </th>
                        <th> Mobile Number </th>
                        <th> Designation </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let member of membersListFromGovEva; let count=index">
                        <td class="process-list-action">
                          <div class="md-checkbox">
                            <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="member.IsSelected"
                              (change)="checkMemberselected($event);">
                            <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                          </div>
                        </td>
                        <td tabindex="1">{{member.FirstName }} {{member.LastName }}</td>
                        <td tabindex="1">{{member.TypeOfUser }}</td>
                        <td tabindex="1">{{member.EmailId }}</td>
                        <td tabindex="1">{{member.MobileNumber }}</td>
                        <td tabindex="1">{{member.Designation }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button id="btnsaveCategory" type="button" class="btn-sm btn btn-primary" (click)="saveMember()"
              [disabled]='hideMemberBtn'>
              <i class="fa fa-check"></i>Add Members</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>Cancel</button>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="modal fade modal-size-large" id="existingInviteeDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <form>
          <div class="modal-header">
            <h5 class="modal-title" id="InviteeLabel">Invitee Details :
            </h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="modal-body">


            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Select Invitee</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <div class="form-group">

                  <select class="form-control" (change)="selectMemberFromInvittee($event)"
                    [(ngModel)]="inviteeGovevaMemberSelectBox" [ngModelOptions]="{standalone: true}">
                    <option value='null' [selected]="true">Select</option>
                    <option *ngFor="let invittee of invitteeListFromGovevea" [value]="invittee._id">
                      <!-- {{invittee.FullName}} -->
                      {{invittee.Title +''+ invittee.FirstName + ' ' +invittee.LastName}}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <input type="hidden" name="govevaUserId" [formControl]="inviteeForm.controls['GovevaUserId']">

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Invitee Name</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['InviteeName']" class="form-control">
                  <div
                    *ngIf="inviteeForm.controls['InviteeName'].hasError('required') && inviteeForm.controls['InviteeName'].touched"
                    class="form-control-error-custom">
                    Invitee Name is required.
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-control-label">Designation</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['Designation']" class="form-control">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Address</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['Address']" class="form-control">
                </div>
              </div>


              <div class="col-md-2">
                <label class="form-control-label">City</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['City']" class="form-control"
                    (keydown)="onlyAlphabates($event)">
                  <div *ngIf="inviteeForm.controls['City'].hasError('pattern') && inviteeForm.controls['City'].touched"
                    class="form-control-error-custom">
                    City is invalid.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">State</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="input-group">
                    <input [formControl]="inviteeForm.controls['State']" class="form-control">
                  </div>

                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Tel(O)</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['TelO']" class="form-control" pattern="^\d{4}\d{3}\d{4}$">
                  <div *ngIf="inviteeForm.controls['TelO'].hasError('pattern') && inviteeForm.controls['TelO'].touched"
                    class="form-control-error-custom">
                    Telephone number is invalid.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Tel(R)</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['TelR']" class="form-control" pattern="^\d{4}\d{3}\d{4}$">
                  <div *ngIf="inviteeForm.controls['TelR'].hasError('pattern') && inviteeForm.controls['TelR'].touched"
                    class="form-control-error-custom">
                    Telephone number is invalid.
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Through VC</label>
              </div>
              <div class="col-md-4">


                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="ThroughVCY" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['ThroughVC']" name="ThroughVC" value="Yes"
                      class="form-check-input">
                    <label for="ThroughVCY">Yes</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="ThroughVCN" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['ThroughVC']" name="ThroughVC" value="No"
                      class="form-check-input">
                    <label for="ThroughVCN">No</label>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Fax No</label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input [formControl]="inviteeForm.controls['FaxNo']" class="form-control" pattern="^\+?[0-9]{7,}$">
                  <div
                    *ngIf="inviteeForm.controls['FaxNo'].hasError('pattern') && inviteeForm.controls['FaxNo'].touched"
                    class="form-control-error-custom">
                    Fax Number is not valid.
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Mobile No</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <input [formControl]="inviteeForm.controls['MobileNo']" id="invitteeMob" class="form-control"
                  pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                <div
                  *ngIf="inviteeForm.controls['MobileNo'].hasError('pattern') && inviteeForm.controls['MobileNo'].touched"
                  class="form-control-error-custom">
                  Mobile Number is not valid.
                </div>
                <div
                  *ngIf="inviteeForm.controls['MobileNo'].hasError('required') && inviteeForm.controls['MobileNo'].touched"
                  class="form-control-error-custom">
                  Mobile Number is required.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <label class="form-control-label">Email Id</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input type="email" [formControl]="inviteeForm.controls['EmailId']"
                    pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" class="form-control">
                  <div
                    *ngIf="inviteeForm.controls['EmailId'].hasError('required') && inviteeForm.controls['EmailId'].touched"
                    class="form-control-error-custom">
                    Email Id is required.
                  </div>
                  <div *ngIf="inviteeForm.controls['EmailId'].hasError('pattern') " class="form-control-error-custom">
                    Email Id is incorrect.
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-control-label">Invitees attendance
                  <span style="color: red;" class="span_margin">*</span>
                </label>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <!-- Radio fields -->
                  <div class="md-radio md-radio-inline">
                    <input id="InAttendanceY" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['InAttendance']" name="InAttendance" value="Yes"
                      class="form-check-input">
                    <label for="InAttendanceY">In-Attendance</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="InAttendanceN" type="radio" style="position:absolute"
                      [formControl]="inviteeForm.controls['InAttendance']" name="InAttendance" value="No"
                      class="form-check-input">
                    <label for="InAttendanceN">Permanent Invitee</label>
                  </div>



                </div>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button id="btnUpdateInviteeRow" type="button" class="btn-sm btn btn-primary"
              [disabled]="!inviteeForm.valid || disabledOnclick" (click)="updateInvitee()" style="display:none">
              <i class="fa fa-save"></i>Update</button>
            <button id="btnaddInviteeRow" type="submit" class="btn-sm btn btn-primary"
              [disabled]="isExistingInvitteeForInvalid || disabledOnclick" (click)="saveInviteeForGoveva()">
              <i class="fa fa-save"></i>Save</button>
            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </form>

      </div>
    </div>
  </div>


  <div class="modal fade" id="clearDataModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to clear Committee details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" [routerLink]="['/committee']" data-dismiss="modal">
            <i class="fa fa-check"></i>Yes</button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>No</button>

        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <span id="deleteModalMessage"></span>
            </div>
          </div>
        </div>
        <div class="modal-footer">


          <button type="button" class="btn btn-sm btn-danger" id="deleteDirector" (click)="deleteDirector()"
            style="display: none">
            <i class="fa fa-check"></i>Confirm</button>
          <button type="button" class="btn btn-sm btn-danger" id="deleteInvitee" (click)="deleteInvitee()"
            style="display: none">
            <i class="fa fa-check"></i>Confirm</button>
          <button type="button" class="btn btn-sm btn-danger" id="deleteMember" (click)="deleteMember()"
            style="display: none">
            <i class="fa fa-check"></i>Confirm</button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>Close</button>
        </div>
      </div>
    </div>
  </div>

  <app-alert></app-alert>
</section>